import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { ITransition, ITransitionModel } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { IRenderRectConfig } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-mobile/type';
import { IContentSize } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/base/types';

export interface ITransitionService {
    /**
     * 更新当前的切页动画类型
     */
    updateTransitionType: (type: TransitionType) => void;
    /**
     * 更新当前页的切页动画效果选项
     */
    updateTransitionEffect: (effect: Partial<ITransition>) => void;
    /**
     * 获取当前页的切页动画数据
     */
    getCurrentSlideTransition: () => ITransitionModel | undefined;
    /**
     * 应用到全部
     */
    applyTransitionToAll: () => void;
    /**
     * 预览
     */
    preview: () => void;
    /**
     * 停止预览
     */
    stopPreview: () => void;
    /**
     * 初始化layer
     */
    initPreviewLayer: (props: IInitPreviewLayerProps) => void;
    /**
     * 更新layer
     */
    updatePreviewLayer: (props: Omit<IInitPreviewLayerProps, 'ref'>) => void;
    /**
     * 是否自动预览
     */
    autoPreviewState: boolean;
    /**
     * 设置自动预览
     */
    toggleAutoPreview: () => void;
    /**
     * 获取预览状态
     */
    getPreviewState: () => boolean;
}

export interface IInitPreviewLayerProps {
    width: number;
    height: number;
    scale: number;
    ref: HTMLDivElement;
    renderRectConfig: IRenderRectConfig;
}

export interface IRenderContext {
    width: number;
    height: number;
    scale: number;
    contentSize: IContentSize;
    scrollLeft: number;
    scrollTop: number;
    currentScrollX?: number;
    currentScrollY?: number;
}

export enum TransitionAutoPreview {
    DISABLE = 0,
    ENABLE = 1,
}
